import { ThreeDot } from "react-loading-indicators";

const Loading = () => {
  return (
    <div className="loading_container">
      <ThreeDot color={"#ff3452"} />
    </div>
  );
};

export default Loading;
